export const MUSIC_VENDOR_KIND = "music-vendor";

/**
 * Music Provider — same approved Master Account shell.
 * Only Uploader, History, Account, User Management.
 */
export const musicVendorExperience = {
  kind: MUSIC_VENDOR_KIND,
  label: "Music Provider",
  landingPath: "/master-account/musicuploader",
  routeRules: [
    {
      prefix: "/master-account/musicuploader",
      capability: "music-vendor.uploads",
    },
    {
      prefix: "/master-account/musichistory",
      capability: "music-vendor.upload-status",
    },
    { prefix: "/master-account/account", capability: "tenant.settings.basic" },
    {
      prefix: "/master-account/user-management",
      capability: "tenant.users.manage",
    },
  ],
};
